type TemplateStringsInterpolation<T> =
  | string
  | number
  | boolean
  | undefined
  | null
  | ((props: T) => string | null | boolean);

export const node = <T>(
  strings: TemplateStringsArray,
  ...interpolations: TemplateStringsInterpolation<T>[]
) => {
  return <K extends HTMLElement>(props: T): K => {
    return createNode<K>(parse(props, strings, ...interpolations));
  };
};

export const html = (
  strings: TemplateStringsArray,
  ...interpolations: TemplateStringsInterpolation<unknown>[]
) => {
  return createNode(parse({}, strings, ...interpolations));
};

const interpolate = <T>(
  props: T,
  interpolation: TemplateStringsInterpolation<T>,
) => {
  switch (typeof interpolation) {
    case "boolean":
      return interpolation.toString();
    case "number":
      return interpolation.toString();
    case "string":
      return interpolation;
    case "function":
      return interpolation(props);
  }

  return "";
};

const parse = <T>(
  props: T,
  strings: TemplateStringsArray,
  ...interpolations: (TemplateStringsInterpolation<T> | undefined)[]
) => {
  return strings
    .map((str, i) => {
      const interpolation = interpolations[i];

      return interpolation !== undefined
        ? `${str}${interpolate(props, interpolation)}`
        : str;
    })
    .join("");
};

const createNode = <K extends HTMLElement>(html: string): K => {
  const div = document.createElement("div");
  div.innerHTML = html;

  return div.children[0] as unknown as K;
};
